import { render, staticRenderFns } from "./nxMobileSlider.vue?vue&type=template&id=dec31072&scoped=true&"
import script from "./nxMobileSlider.vue?vue&type=script&lang=js&"
export * from "./nxMobileSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec31072",
  null
  
)

export default component.exports